import { Fragment, useEffect, useRef, useState } from "react";
import jwt_decode from "jwt-decode";
import format from 'format-number'
import { Alert, Box, Button, Checkbox, Collapse, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, FormGroup, Grid, IconButton, TextField } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

export default function EditarDocumentosValeCaja(props) {
    const { solicitud, setSolicitud } = props
    const token = sessionStorage.getItem('token')
    const decoded = jwt_decode(token);

    const idResponsable = decoded.id;

    const [factura, setFactura] = useState({ monto: '', fecha: null, documentos: new FormData(), indice: 0, rutaPDF: null, rutaXML: null })

    const [errorMonto, setErrorMonto] = useState(false)
    const [helperTextMonto, setHelperTextMonto] = useState('')
    const [errorFecha, setErrorFecha] = useState(false)
    const [errorDocumentoPDF, setErrorDocumentoPDF] = useState(false)
    const [helperTextDocumentoPDF, setHelperTextDocumentoPDF] = useState('')
    const [errorDocumentoXML, setErrorDocumentoXML] = useState(false)
    const [helperTextDocumentoXML, setHelperTextDocumentoXML] = useState('')
    const [openMensaje, setOpenMensaje] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [open, setOpen] = useState(false);
    const [checkedComprobante, setCheckedComprobante] = useState(false);
    const [facturas, setFacturas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('error')
    const documentoPDF = useRef(null)
    const documentoXML = useRef(null)
    const monto = useRef(null)
    const limpiar = useRef(null)

    const handleChecked = (event) => {
        setCheckedComprobante(event.target.checked);
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        //solicitud.valeCajas[0]={...valeCaja}        
        setOpen(false);
        setErrorMonto(false)
        setHelperTextMonto('')
        setHelperTextDocumentoPDF('')
        setErrorDocumentoPDF(false)
        setHelperTextDocumentoXML('')
        setErrorDocumentoXML(false)
    };
    const cargarFechas = async (anio) => {

        const entidad = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/entidad/${sessionStorage.getItem('idEntidad')}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })
        const entidadLeida = await entidad.json()
        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/configuracionFechas/configuracion/${anio}/${entidadLeida.idEntidadSuperior ? entidadLeida.idEntidadSuperior : entidadLeida.id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })
        const fechasLeidas = await res.json()
        //console.log(`FECHAS LEIDAS ${fechasLeidas.activarMontosPrioridad2}`)

        const fechaCierreAdquisiciones = new Date(fechasLeidas.cierreAdquisiciones)
        fechaCierreAdquisiciones.setDate(fechaCierreAdquisiciones.getDate() + 1);
    }

    const leerUsuario = async () => {

        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/informeProyecto/proyectos/${idResponsable}/false/${sessionStorage.getItem('idEntidad')}`, { //Siempre es gestión por eso se pone false
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })
        if (res.status === 404) {
            //console.log('regresó 404 en asistencia Eventos')//poner mensaje de error
            return
        }
        else {
            //console.log('si hay proyectos')
            const data = await res.json()
            //console.log(data)

            const idPlan = data[0].idPlan
            //console.log(`IDPLAN ${data[0].idPlan}`)
            const resPlan = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/planeacion/${idPlan}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                }
            }
            )
            const plan = await resPlan.json()
            //console.log(`ANIO ${plan.anio}`)
            await cargarFechas(plan.anio)
            //console.log(`ANIO ${plan.anio}`)
        }

    }

    const desplegarDocumentoPDF = async (value) => {
        //console.log(`value en desplegarDocumentoPDF ${value}`)
        await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/mostrarDocumentoPDF`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil'),
                "documento": JSON.stringify(value)
            },

        }
        ).then((res) => res.blob())
            .then((blob) => { // RETRIEVE THE BLOB AND CREATE LOCAL URL
                var _url = window.URL.createObjectURL(blob);
                window.open(_url, "_blank").focus(); // window.open + focus
            }).catch((err) => {
                console.error(err);
            });
    }

    const colocarNombre = (ruta) => {
        if (!ruta || ruta === '')
            return ''
        const indice = Number(ruta.indexOf("factura")) + 9
        return ruta.slice(indice)

    }
    useEffect(() => {

        (async () => {
            await leerUsuario();

        })();
        setFacturas(solicitud.valeCajas[0].facturaValeCajas)
        // eslint-disable-next-line
    }, [factura]);


    const handleDelete = async (id) => {
        //console.log(`gastos viaje id ${solicitud.valeCajas[0].id}`)
        setLoading(true)
        try {
            await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/facturaValeCaja/${id}`, {
                method: "DELETE",
                headers: {
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                }
            })

            //viaticos.facturaValeCajas=viaticos.facturaValeCajas.filter((viaticos.facturaValeCajas) => (viaticos.facturaValeCajas.id) != id)
            //console.log(`Facturas sin filtrar ${JSON.stringify(facturas)}`)

            const facturasFiltradas = facturas.filter(facturas => facturas.id !== id)
            setFacturas(facturasFiltradas)
            solicitud.valeCajas[0].facturaValeCajas = facturasFiltradas
            //console.log(`Facturas filtradas ${JSON.stringify(facturasFiltradas)}`)
            setSolicitud({ ...solicitud })

        } catch (error) {
            console.error(error)
        }
        setLoading(false)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!factura.rutaPDF) {
            const archivoPDF = new FormData();
            archivoPDF.append('factura', factura.documentos.get('PDF'));
            const resUploadPDF = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/uploadFacturas`, {
                headers: { "escomprobante": solicitud.valeCajas[0].pais !== 'MEXICO' || (!factura.rutaXML && !factura.documentos.get('XML')) },
                method: "POST",
                body: archivoPDF
            })
            factura.rutaPDF = (await resUploadPDF.json()).ruta
        }
        if (!factura.rutaXML) {

            if (factura.documentos.get('XML')) {
                //console.log(`factura.documentos.get('XML') dentro del if`)
                const archivoXML = new FormData();
                archivoXML.append('factura', factura.documentos.get('XML'));
                const resUploadXML = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/uploadFacturas`, {
                    method: "POST",
                    body: archivoXML
                })
                factura.rutaXML = (await resUploadXML.json()).ruta
            }
        }

        factura.idValeCaja = solicitud.valeCajas[0].id

        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/facturaValeCaja`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            },
            body: JSON.stringify(factura)
        })

        const data = await res.json()
        if (res.status === 200) {
            setSeverity('success')
            solicitud.valeCajas[0].facturaValeCajas.push(data)
            setFacturas(solicitud.valeCajas[0].facturaValeCajas)
            setFactura({ monto: null, fecha: null, documentos: new FormData(), indice: 0, rutaPDF: null, rutaXML: null })
            setSolicitud({ ...solicitud })
            if (documentoPDF.current)
                documentoPDF.current.value = ''
            if (documentoXML.current)
                documentoXML.current.value = ''
            if (monto.current)
                monto.current.value = ''
            if(limpiar.current)
                limpiar.current.click()
            /*document.getElementById('documentoPDF').value = ''
            if (document.getElementById('documentoXML'))
                document.getElementById('documentoXML').value = ''
            document.getElementById('monto').value = ''*/
            setHelperTextMonto('')
            setHelperTextDocumentoPDF('')
            setHelperTextDocumentoXML('')
            setErrorDocumentoPDF(false)
            setErrorDocumentoXML(false)
            setOpenMensaje(true)
            setMensaje("Se registró el comprobante/factura")
        }
        else
            setSeverity('error')
        if (data.message) {
            setOpenMensaje(true)
            setMensaje(data.message)
            return
        }

    }

    return (
        <>
            <Grid container justifyContent='stretch' spacing={5} style={{ marginTop: 5 }}>
                <Grid item xs={3} style={{ fontWeight: "bold" }}>
                    Fecha
                </Grid>
                <Grid item xs={3} style={{ fontWeight: "bold" }}>
                    Documentos
                </Grid>
                <Grid item xs={3} style={{ fontWeight: "bold" }}>
                    Monto
                </Grid>
                <Grid item xs={3}></Grid>
                {facturas && facturas.length > 0 ?
                    facturas.map((factura) => {
                        return (
                            <Fragment key={factura.id}>
                                <Grid item xs={3}>
                                    {factura.fecha}
                                </Grid>
                                <Grid item xs={3}>
                                    <span style={{ wordBreak: 'break-word' }}>
                                        <Button color='success' size='small' onClick={async () => { await desplegarDocumentoPDF(factura) }}>{colocarNombre(factura.rutaPDF)}</Button><br />{factura.rutaXML ? <Button color='success' size='small' href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoXML/${colocarNombre(factura.rutaXML)}`} download={colocarNombre(factura.rutaXML)}>{colocarNombre(factura.rutaXML)}</Button> : <></>}
                                    </span>
                                </Grid>
                                <Grid item xs={3}>
                                    {format({ prefix: '$' })(factura.monto)}
                                </Grid>
                                <Grid item xs={3}>
                                    <Button variant='contained' style={{ marginLeft: 5, backgroundColor: "darkred", color: 'white' }} onClick={() => handleDelete(factura.id)} disabled={loading}>Eliminar</Button>
                                </Grid>
                            </Fragment>)
                    }) : <></>}
            </Grid>
            <Grid item sx={{ marginTop: 5 }}>
                <Button variant='contained' style={{ marginTop: 20, backgroundColor: "darkgreen", color: 'white' }} type='button' onClick={handleClickOpen}>
                    Añadir comprobantes
                </Button>
            </Grid>

            <Dialog open={open}>
                {solicitud ? <form onSubmit={handleSubmit}>
                    <DialogTitle>{'Añadir comprobante'} {`a la solicitud ${solicitud.folio}`} </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                        </DialogContentText>
                        <Grid container justifyContent='stretch' spacing={5} style={{ marginTop: 5 }}>
                            <Grid item xs={12}>
                                <FormGroup>
                                    <FormControlLabel control={<Checkbox checked={checkedComprobante}
                                        onChange={handleChecked} inputProps={{ 'aria-label': 'controlled' }} />}
                                        label="Comprobante" />
                                </FormGroup>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField name="monto" ref={monto} label="Monto" required value={factura.monto} onChange={(e) => {
                                    const valor = e.target.value
                                    const valorNumerico = valor.replace(/,/g, '')
                                    setFactura({ ...factura, 'monto': valorNumerico })

                                    if (solicitud.valeCajas[0].tipoServicio === 'aComprobar') {
                                        // Verificar que todas las facturas con la misma fecha no excedan el montoMaximoDia
                                        // y que el monto acumulado de todos los comprobantes y facturas no exceda el monto asignado

                                        let montoAcumulado = Number(valorNumerico)
                                        //console.log(`\n\n viaticos.facturaValeCajas ${JSON.stringify(viaticos.facturaValeCajas)}\n\n`)
                                        facturas.map((facturaGuardada) => {
                                            montoAcumulado = Number(montoAcumulado) + Number(facturaGuardada.monto)
                                        })

                                        if (Number(solicitud.valeCajas[0].monto) < Number(montoAcumulado)) {
                                            setErrorMonto(true)
                                            setHelperTextMonto(`La suma de los montos de los comprobantes ${format({ prefix: '$' })(montoAcumulado)} no debe exceder el monto asignado ${format({ prefix: '$' })(solicitud.valeCajas[0].monto)}.`)
                                            return
                                        }
                                        else {
                                            setErrorMonto(false)
                                            setHelperTextMonto('')
                                        }
                                    }
                                    else {
                                        if (Number(valorNumerico) > Number(solicitud.valeCajas[0].monto)) {
                                            setErrorMonto(true)
                                            setHelperTextMonto(`No debe exceder el monto máximo de reembolso ${format({ prefix: '$' })(solicitud.valeCajas[0].monto)}`)
                                            return
                                        }
                                        else {
                                            setErrorMonto(false)
                                            setHelperTextMonto('')
                                        }
                                        // Verificar que todas las facturas con la misma fecha no excedan el montoMaximoDia
                                        // y que el monto acumulado de todos los comprobantes y facturas no exceda el monto asignado

                                        let montoAcumulado = Number(valorNumerico)
                                        facturas.map((facturaGuardada) => {

                                            montoAcumulado = Number(montoAcumulado) + Number(facturaGuardada.monto)
                                        })

                                        if (Number(solicitud.valeCajas[0].monto) < Number(montoAcumulado) && (Number(solicitud.valeCajas[0].monto) - (Number(montoAcumulado) - Number(valorNumerico))) <= 0) {
                                            setErrorMonto(true)
                                            setHelperTextMonto(`Ya no se pueden añadir más comprobantes. La suma de los montos de los comprobantes ${format({ prefix: '$' })(montoAcumulado)} no debe exceder el monto asignado ${format({ prefix: '$' })(Number(solicitud.valeCajas[0].monto))}.`)
                                            return
                                        }
                                        else {
                                            setErrorMonto(false)
                                            setHelperTextMonto('')
                                        }

                                        if (Number(solicitud.valeCajas[0].monto) < Number(montoAcumulado) && (Number(solicitud.valeCajas[0].monto) - (Number(montoAcumulado) - Number(valorNumerico))) > 0) {
                                            setHelperTextMonto(`Considerar sólo por ${format({ prefix: '$' })(Number(solicitud.valeCajas[0].monto) - (Number(montoAcumulado) - Number(valorNumerico)))}.`)
                                            setFactura({ ...factura, 'monto': Number(solicitud.valeCajas[0].monto) - (Number(montoAcumulado) - Number(valorNumerico)) })
                                            setErrorMonto(false)
                                            return
                                        }
                                    }

                                }} focused helperText={helperTextMonto} error={errorMonto} sx={{ width: '100%' }} />

                            </Grid>

                            <Grid item xs={12}>
                                <TextField label={`${!checkedComprobante ? 'Factura PDF' : 'Comprobante PDF, PNG, JPG, JPEG'}`} ref={documentoPDF} name='documentoPDF' focused required type='file' accept="application/pdf" helperText={helperTextDocumentoPDF} error={errorDocumentoPDF} onChange={async (event) => {
                                    factura.documentos.delete('PDF')
                                    const file = event.target.files[0]
                                    if (event.target.value) {
                                        //console.log(`event.target.value ${event.target.value} ${event.target.value.endsWith(".jpg")}`)
                                        if (event.target.value.endsWith(".PDF") || event.target.value.endsWith(".pdf") || ((checkedComprobante || solicitud.valeCajas[0].pais !== 'MEXICO') && (event.target.value.endsWith(".PNG") || event.target.value.endsWith(".png") || event.target.value.endsWith(".JPG") || event.target.value.endsWith(".jpg") || event.target.value.endsWith(".JPEG") || event.target.value.endsWith(".jpeg")))) {

                                            setHelperTextDocumentoPDF('')
                                            setErrorDocumentoPDF(false)
                                        }
                                        else {
                                            setHelperTextDocumentoPDF(`Formato de archivo no válido, se requiere PDF ${checkedComprobante || solicitud.valeCajas[0].pais !== 'MEXICO' ? ' PNG, JPG o JPEG' : ''}`)
                                            setErrorDocumentoPDF(true)
                                            return
                                        }
                                        if (file.size > 5242880) {
                                            setHelperTextDocumentoPDF('El tamaño del archivo debe ser menor a 5MB')
                                            setErrorDocumentoPDF(true)
                                            return
                                        }
                                        else {
                                            setHelperTextDocumentoPDF('')
                                            setErrorDocumentoPDF(false)
                                        }

                                        setHelperTextDocumentoPDF('')
                                        setErrorDocumentoPDF(false)
                                        let regex = /([^-\w.]*)/gm;
                                        const nombreArchivo = file.name.replace(regex, '');
                                        let error = false
                                        facturas.map((facturaGuardada) => {
                                            //console.log(`facturaGuardada.rutaPDF ${facturaGuardada.rutaPDF} && facturaGuardada.rutaPDF.includes(nombre ${nombre}) ${facturaGuardada.rutaPDF.includes(nombre)}`)                                                
                                            if (facturaGuardada.rutaPDF && facturaGuardada.rutaPDF.includes(nombreArchivo)) {
                                                setHelperTextDocumentoPDF('Ese documento ya está registrado en el listado de la solicitud')
                                                setErrorDocumentoPDF(true)
                                                error = true
                                            }
                                        })
                                        solicitud.valeCajas[0].facturaValeCajas.map((facturaGuardada) => {
                                            //console.log(`facturaGuardada.rutaPDF ${facturaGuardada.rutaPDF} && facturaGuardada.rutaPDF.includes(nombre ${nombre}) ${facturaGuardada.rutaPDF.includes(nombre)}`)                                                
                                            if (facturaGuardada.rutaPDF && facturaGuardada.rutaPDF.includes(nombreArchivo)) {
                                                setHelperTextDocumentoPDF('Ese documento ya está registrado en el listado de la solicitud')
                                                setErrorDocumentoPDF(true)
                                                error = true
                                            }
                                        })
                                        if (error)
                                            return
                                        if (checkedComprobante || solicitud.valeCajas[0].pais !== 'MEXICO') {
                                           /* YA NO SE VERIFICA SI ES UN COMPROBANTE const resVerificar = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/verificarImagen`, {
                                                method: "GET",
                                                headers: {
                                                    "nombre": nombreArchivo,
                                                    "carpeta": "facturas"
                                                }
                                            })
                                            if (resVerificar.status === 200) {
                                                //setErrorDocumentoPDF(true)
                                                setHelperTextDocumentoPDF('Ya existe un archivo registrado con ese nombre. Si no lo subiste tú en un intento anterior por favor renombra tu archivo y trata de subirlo de nuevo, de lo contrario se colocará el enlace al archivo existente')
                                                const data = await resVerificar.json()
                                                //console.log(`data ${data.ruta}`)
                                                setFactura({ ...factura, rutaPDF: data.ruta })

                                                returnX
                                            }
                                            else {
                                                setFactura({ ...factura, rutaPDF: null })
                                                setErrorDocumentoPDF(false)
                                                setHelperTextDocumentoPDF('')
                                            }*/

                                        }
                                        else {

                                            const resVerificar = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/verificarPDF`, {
                                                method: "GET",
                                                headers: {
                                                    "nombre": nombreArchivo,
                                                    "carpeta": "facturas"
                                                }
                                            })
                                            if (resVerificar.status === 200) {
                                                //setErrorDocumentoPDF(true)
                                                setHelperTextDocumentoPDF('Ya existe un archivo registrado con ese nombre. Si no lo subiste tú en un intento anterior por favor renombra tu archivo y trata de subirlo de nuevo, de lo contrario se colocará el enlace al archivo existente')
                                                const data = await resVerificar.json()
                                                //console.log(`data ${data.ruta}`)
                                                setFactura({ ...factura, rutaPDF: data.ruta })

                                                return
                                            }
                                            else {
                                                setFactura({ ...factura, rutaPDF: null })
                                                setErrorDocumentoPDF(false)
                                                setHelperTextDocumentoPDF('')
                                            }
                                        }
                                    }
                                    //console.log(`Files[0] ${file.name}`)
                                    factura.documentos.append('PDF', file)
                                }} sx={{ width: '100%' }} />
                            </Grid>

                            {!checkedComprobante ?
                                <Grid item xs={12}>
                                    <TextField label='Factura XML' ref={documentoXML} name='documentoXML' focused required type='file' accept="application/xml" helperText={helperTextDocumentoXML} error={errorDocumentoXML} onChange={async (event) => {
                                        factura.documentos.delete('XML')
                                        const file = event.target.files[0]
                                        if (event.target.value) {
                                            if (event.target.value.endsWith(".XML") || event.target.value.endsWith(".xml")) {
                                                setHelperTextDocumentoXML('')
                                                setErrorDocumentoXML(false)
                                            }
                                            else {
                                                setHelperTextDocumentoXML('Formato de archivo no válido, se requiere XML')
                                                setErrorDocumentoXML(true)
                                                return
                                            }
                                            if (file.size > 5242880) {
                                                setHelperTextDocumentoXML('El tamaño del archivo debe ser menor a 5MB')
                                                setErrorDocumentoXML(true)
                                                return
                                            }
                                            else {
                                                setHelperTextDocumentoXML('')
                                                setErrorDocumentoXML(false)
                                            }

                                            setHelperTextDocumentoXML('')
                                            setErrorDocumentoXML(false)

                                            let regex = /([^-\w.]*)/gm;
                                            const nombreArchivo = file.name.replace(regex, '');

                                            let error = false
                                            solicitud.valeCajas[0].facturaValeCajas.map((facturaGuardada) => {
                                                //console.log(`facturaGuardada.rutaPDF ${facturaGuardada.rutaPDF} && facturaGuardada.rutaPDF.includes(nombre ${nombre}) ${facturaGuardada.rutaPDF.includes(nombre)}`)                                                
                                                if (facturaGuardada.rutaXML && facturaGuardada.rutaXML.includes(nombreArchivo)) {
                                                    setHelperTextDocumentoXML('Ese documento ya está registrado en el listado de la solicitud')
                                                    setErrorDocumentoXML(true)
                                                    error = true
                                                }
                                            })
                                            facturas.map((facturaGuardada) => {
                                                if (facturaGuardada.rutaXML && facturaGuardada.rutaXML.includes(nombreArchivo)) {
                                                    setHelperTextDocumentoXML('Ese documento ya está registrado en el listado de la solicitud')
                                                    setErrorDocumentoXML(true)
                                                    error = true
                                                }
                                            })

                                            if (error)
                                                return

                                            const resVerificar = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/verificarFacturaXML`, {
                                                method: "GET",
                                                headers: {
                                                    "nombre": nombreArchivo,
                                                    "carpeta": "facturas"
                                                }
                                            })
                                            if (resVerificar.status === 200) {
                                                //setErrorDocumentoXML(true)
                                                setHelperTextDocumentoXML('Ya existe un archivo registrado con ese nombre. Si no lo subiste tú en un intento anterior por favor renombra tu archivo y trata de subirlo de nuevo, de lo contrario se colocará el enlace al archivo existente')
                                                const data = await resVerificar.json()
                                                //console.log(`data ${data.ruta}`)
                                                setFactura({ ...factura, rutaXML: data.ruta })

                                                return
                                            }
                                            else {
                                                setErrorDocumentoXML(false)
                                                setHelperTextDocumentoXML('')
                                                setFactura({ ...factura, rutaXML: null })

                                            }
                                        }
                                        //console.log(`Files[0] ${file.name}`)
                                        factura.documentos.append('XML', file)
                                        //factura.documentos.push(file)
                                    }} sx={{ width: '100%' }} />
                                </Grid>
                                : <></>}
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cerrar</Button>
                        <Button type='submit' disabled={errorMonto || errorDocumentoPDF || errorDocumentoXML || errorFecha}>Guardar</Button>
                        <Button type='reset' ref={limpiar} onClick={() => { setErrorDocumentoPDF(false); setErrorDocumentoXML(false); setHelperTextDocumentoPDF(''); setHelperTextDocumentoXML(''); setFactura({ monto: null, fecha: null, documentos: new FormData(), indice: 0, rutaPDF: null, rutaXML: null }) }}>Limpiar</Button>
                    </DialogActions>
                </form> : <></>}
            </Dialog>
            <Box sx={{ width: '100%' }}>
                <Collapse in={openMensaje}>
                    <Alert severity={severity}
                        action={
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                    setOpenMensaje(false);
                                }}
                            >
                                <CloseIcon fontSize="inherit" />
                            </IconButton>
                        }
                        style={{ marginTop: 30 }}
                    >
                        {mensaje}
                    </Alert>
                </Collapse>
            </Box>
        </>
    )
}